import inverted_synth from "./img/sister-triangle-inverted.jpg"

import {calculator_images, arp_images, sampler_images, sub_images, tri_images, dm_images, clock_images, scratch_images, dabba_images} from "./img/images.js";

const logotext = "sister engineering";
const meta = {
    title: "sister engineering",
    description: "I’m John Doe data scientist _ Full stack devloper,currently working in Berlin",
};

const introdata = {
    // title: "I’m John Doe",
    // animated: {
    //     first: "I love coding",
    //     second: "I code cool websites",
    //     third: "I develop mobile apps",
    // },
    // description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed at nisl euismod urna bibendum",
    home_image:inverted_synth,
};

const dataabout = {
    title: "abit about my self",
    aboutme: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent quis dolor id ligula semper elementum feugiat pretium nulla. Nunc non commodo dolor. Nunc mollis dignissim facilisis. Morbi ut magna ultricies.",
};
const worktimeline = [{
        jobtitle: "Designer of week",
        where: "YAdfi",
        date: "2020",
    },
    {
        jobtitle: "Designer of week",
        where: "Jamalya",
        date: "2019",
    },
    {
        jobtitle: "Designer of week",
        where: "ALquds",
        date: "2019",
    },
];

const skills = [{
        name: "Python",
        value: 90,
    },
    {
        name: "Djano",
        value: 85,
    },
    {
        name: "Javascript",
        value: 80,
    },
    {
        name: "React",
        value: 60,
    },
    {
        name: "Jquery",
        value: 85,
    },
];

const services = [{
        title: "UI & UX Design",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed at nisl euismod urna bibendum sollicitudin.",
    },
    {
        title: "Mobile Apps",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed at nisl euismod urna bibendum sollicitudin.",
    },
    {
        title: "Wordpress Design",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed at nisl euismod urna bibendum sollicitudin.",
    },
];

const calc_images=[calculator_images.calc_1, calculator_images.calc_2,  calculator_images.calc_3, calculator_images.calc_4,  calculator_images.calc_5, calculator_images.calc_gif,];
const arpeggiator_images=[arp_images.arp_1, arp_images.arp_2, arp_images.arp_3, arp_images.arp_gif,];
const synth_images=[tri_images.tri_1, tri_images.tri_2, tri_images.tri_3, tri_images.tri_4, tri_images.tri_5, tri_images.tri_6];
const submarine_images=[sub_images.sub_1, sub_images.sub_2, sub_images.sub_3, sub_images.sub_4];
const samper_images=[sampler_images.sampler_1, sampler_images.sampler_2, sampler_images.sampler_3, sampler_images.sampler_4];
const drone_machine_images=[dm_images.dm_1, dm_images.dm_2, dm_images.dm_3, dm_images.dm_4, dm_images.dm_5, dm_images.dm_6];
const clock_images_array=[clock_images.clock_1, clock_images.clock_2];
const scratch_images_array=[scratch_images.scratch_1, scratch_images.scratch_2, scratch_images.scratch_3, scratch_images.scratch_4, scratch_images.scratch_5, scratch_images.scratch_6, scratch_images.scratch_7];
const dabba_images_array=[dabba_images.dabba_1];

const dataportfolio = [{
        img: calc_images[0],
        description: "The wisdom of life consists in the elimination of non-essentials.",
        link: "#",
    },
    {
        img: "https://picsum.photos/400/800/?grayscale",
        description: "The wisdom of life consists in the elimination of non-essentials.",
        link: "#",
    },
    {
        img: "https://picsum.photos/400/?grayscale",
        description: "The wisdom of life consists in the elimination of non-essentials.",
        link: "#",
    },
    {
        img: "https://picsum.photos/400/600/?grayscale",
        description: "The wisdom of life consists in the elimination of non-essentials.",
        link: "#",
    },
    {
        img: "https://picsum.photos/400/300/?grayscale",
        description: "The wisdom of life consists in the elimination of non-essentials.",
        link: "#",
    },
    {
        img: "https://picsum.photos/400/700/?grayscale",
        description: "The wisdom of life consists in the elimination of non-essentials.",
        link: "#",
    },

    {
        img: "https://picsum.photos/400/600/?grayscale",
        description: "The wisdom of life consists in the elimination of non-essentials.",
        link: "#",
    },
    {
        img: "https://picsum.photos/400/300/?grayscale",
        description: "The wisdom of life consists in the elimination of non-essentials.",
        link: "#",
    },
    {
        img: "https://picsum.photos/400/?grayscale",
        description: "The wisdom of life consists in the elimination of non-essentials.",
        link: "#",
    },
    {
        img: "https://picsum.photos/400/550/?grayscale",
        description: "The wisdom of life consists in the elimination of non-essentials.",
        link: "#",
    },
    {
        img: "https://picsum.photos/400/?grayscale",
        description: "The wisdom of life consists in the elimination of non-essentials.",
        link: "#",
    },
    {
        img: "https://picsum.photos/400/700/?grayscale",
        description: "The wisdom of life consists in the elimination of non-essentials.",
        link: "#",
    },
];

const contactConfig = {
    YOUR_EMAIL: "sisterengineering@gmail.com",
    YOUR_FONE: "(347) 602-2075",
    YOUR_SERVICE_ID: "service_id",
    YOUR_TEMPLATE_ID: "template_id",
    YOUR_USER_ID: "user_id",
};

const socialprofils = {
    github: "https://github.com",
    facebook: "https://facebook.com",
    linkedin: "https://linkedin.com",
    twitter: "https://twitter.com",
};
export {
    calc_images,
    arpeggiator_images,
    synth_images,
    submarine_images,
    samper_images,
    drone_machine_images,
    clock_images_array,
    scratch_images_array,
    dabba_images_array,
    meta,
    dataabout,
    dataportfolio,
    worktimeline,
    skills,
    services,
    introdata,
    contactConfig,
    socialprofils,
    logotext,
};